import axios from 'axios'

axios.interceptors.response.use((response) => {
    return response
}, error => {
    if (axios.isCancel(error)) {
        return Promise.reject(error)
    } 
    return Promise.reject(error)
})

export const httpClient = axios
